import ReactGA from "react-ga4";
import { useCallback } from "react";

const isProd = process.env.REACT_APP_ENV === "PROD";

export const UseGA = () => {

  const trackEvent = useCallback((category, action, label, value) => {
    if (isProd) {
      ReactGA.event({
        category: category || "User",
        action: action || "Clicked Button",
        label: label || "Button",
        value: value || 1,
      });

      if (window.clarity) {
        window.clarity(
          "set",
          category || "User",
          `${action || "Click"}: ${label || "Button"}`,
        );
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "customEvent",
        eventCategory: category || "User",
        eventAction: action || "Clicked Button",
        eventLabel: label || "Button",
        eventValue: value || 1,
      });
    }
  }, []);

  return { trackEvent };
};
